import { render, staticRenderFns } from "./mini-info.vue?vue&type=template&id=27a7f4a6&scoped=true&"
import script from "./mini-info.vue?vue&type=script&lang=js&"
export * from "./mini-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a7f4a6",
  null
  
)

export default component.exports